var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInfoCircle0(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 10,
    viewBox: "0 0 10 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3564_44794)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.9987 6.66732L4.9987 5.00065M4.9987 3.33398H5.00286M9.16536 5.00065C9.16536 7.30184 7.29988 9.16732 4.9987 9.16732C2.69751 9.16732 0.832031 7.30184 0.832031 5.00065C0.832031 2.69946 2.69751 0.833984 4.9987 0.833984C7.29988 0.833984 9.16536 2.69946 9.16536 5.00065Z",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3564_44794"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 10,
    height: 10,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoCircle0);
export default __webpack_public_path__ + "static/media/info-circle0.927e6b9fc9a4125afb13100b306396e3.svg";
export { ForwardRef as ReactComponent };